import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarDays, ListTodo } from "lucide-react";
import { useCanvasEditingEnabled } from "../../lib/schedule-art/canvas-state";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { MetadataCanvasToolbar } from "../preview-canvas/MetadataCanvasToolbar";
import { ScheduleArtCanvas } from "../preview-canvas/ScheduleArtCanvas";
import { ScheduleTimeVisualizer } from "../calendar-visualizer/ScheduleTimeVisualizer";
import { ArtworkPreviewControls } from "../metadata-builder/ArtworkPreviewControls";

export function ScheduleArtPreviewPanel() {
  const { t } = useTranslation();
  const editingEnabled = useCanvasEditingEnabled();
  const builderActive = useMetadataBuilderStore(state => state.active);
  const [previewTab, setPreviewTab] = useState("canvas");
  const [calendarOpened, setCalendarOpened] = useState(false);

  return (
    <section className="flex h-full min-h-0 min-w-0 flex-col overflow-hidden rounded border border-neutral-200 bg-white p-4 min-[480px]:p-5" aria-label={t("schedule.preview")}>
      {builderActive && <ArtworkPreviewControls />}
      <Tabs value={builderActive ? "canvas" : previewTab} onValueChange={value => { setPreviewTab(value); if (value === "calendar") setCalendarOpened(true); }} className="flex min-h-0 flex-1 flex-col">
        <TabsList variant="line" className={builderActive ? "hidden" : "shrink-0 self-start"}>
          <TabsTrigger value="canvas" className="gap-2"><ListTodo className="size-4" />{t("preview.canvasTab")}</TabsTrigger>
          <TabsTrigger value="calendar" className="gap-2"><CalendarDays className="size-4" />{t("preview.calendarTab")}</TabsTrigger>
        </TabsList>
        <TabsContent forceMount value="canvas" className="flex min-h-0 flex-1 flex-col gap-3 data-[state=inactive]:hidden">
          <ScheduleArtCanvas />
          {editingEnabled && <div className="max-h-[55%] shrink-0 overflow-y-auto overscroll-contain [scrollbar-gutter:stable]"><MetadataCanvasToolbar /></div>}
        </TabsContent>
        <TabsContent forceMount value="calendar" className="min-h-0 flex-1 overflow-y-auto overscroll-contain [scrollbar-gutter:stable] data-[state=inactive]:hidden">
          {calendarOpened && <ScheduleTimeVisualizer />}
        </TabsContent>
      </Tabs>
    </section>
  );
}
